import { Navigate, useParams } from 'react-router-dom';
import { useOrgPublicProfile } from '@/contexts/OrgPublicProfileContext';
import { useOrgPaths } from '@/hooks/useOrgPaths';

/** Legacy `/play/:slug` URLs redirect to `/play?event=slug` so the modal opens in-place. */
export default function PublicPlayEventPage() {
  const { slug } = useParams<{ slug: string }>();
  const { profile } = useOrgPublicProfile();
  const { p } = useOrgPaths(profile?.organization ?? null);
  const pathFor = p ?? ((sub: string) => sub);

  if (!slug) {
    return <Navigate to={pathFor('/play')} replace />;
  }

  return (
    <Navigate
      to={`${pathFor('/play')}?event=${encodeURIComponent(slug)}`}
      replace
    />
  );
}
